import React from "react";
import Logo from "./Logo";

const PrivacyPage = () => (
  <div className="min-h-screen bg-slate-950 text-slate-100 font-sans">
    <header className="fixed w-full z-50 bg-slate-950/95 backdrop-blur-md shadow-lg border-b border-slate-800 py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <a href="/" className="flex items-center hover:opacity-80 transition-opacity">
          <Logo />
        </a>
        <a
          href="/terms"
          className="text-sm text-sky-400 hover:text-sky-300 transition-colors border border-sky-500/40 rounded-lg px-3 py-1.5"
        >
          Terms of Use
        </a>
      </div>
    </header>

    <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-10 space-y-10">
      <div>
        <p className="text-sky-400 uppercase text-xs font-semibold tracking-widest mb-3">Privacy Policy</p>
        <h1 className="text-4xl font-bold text-white mb-4">CloudMortgage.io Privacy Policy</h1>
        <p className="text-slate-400">
          This Policy explains how CloudMortgage.io handles information for lenders, their teams, and invited borrowers.
          By using the platform, you consent to these practices.
        </p>
      </div>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Information we collect</h2>
        <ul className="list-disc list-inside text-slate-400 space-y-2">
          <li>Account data (name, email, organization), authentication credentials, and usage logs.</li>
          <li>Borrower case data and documents you or your invitees upload or connect via third parties.</li>
          <li>Device and diagnostic data (browser type, IP, performance metrics) to secure and improve the service.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">How we use information</h2>
        <ul className="list-disc list-inside text-slate-400 space-y-2">
          <li>Provide, secure, and improve the platform, including document handling and AI-assisted summaries.</li>
          <li>Detect, prevent, and respond to security incidents and abuse.</li>
          <li>Support customers, communicate about service changes, and meet legal or compliance obligations.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Sharing</h2>
        <p className="text-slate-400">
          We do not sell personal information. We may share data with service providers (e.g., cloud hosting, document
          storage, analytics) under confidentiality and security commitments. Data shared with third-party integrations
          (e.g., Google Drive) is governed by those providers’ terms and your configuration.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Security</h2>
        <p className="text-slate-400">
          We use administrative, technical, and physical safeguards to protect data in transit and at rest. No system is
          entirely risk-free; maintain strong passwords and limit access to authorized users.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Data retention</h2>
        <p className="text-slate-400">
          We retain information for as long as needed to provide the service and meet legal requirements. You may request
          deletion of your account data; some records may be retained where legally required or for legitimate business
          purposes.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Your choices</h2>
        <ul className="list-disc list-inside text-slate-400 space-y-2">
          <li>Access, correct, or delete certain account information via your account or by contacting support.</li>
          <li>Disconnect third-party integrations (e.g., Drive) in your provider settings and within the platform.</li>
          <li>Manage marketing communications by using unsubscribe links or contacting support.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">International use</h2>
        <p className="text-slate-400">
          If you access the platform from outside the United States, you consent to processing and storage in the United
          States and any region where our service providers operate.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Updates</h2>
        <p className="text-slate-400">
          We may update this Policy from time to time. Material changes will be posted with an updated effective date.
          Continued use after changes signifies acceptance.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Contact</h2>
        <p className="text-slate-400">Questions or requests? Contact support@cloudmortgage.io.</p>
      </section>

      <div className="pt-6">
        <a
          href="/"
          className="inline-flex items-center justify-center px-5 py-3 rounded-lg bg-sky-600 text-white font-semibold hover:bg-sky-500 transition-colors"
        >
          Return to Home
        </a>
      </div>
    </main>
  </div>
);

export default PrivacyPage;
